import React from 'react';
import './CreditModal.css';

const CreditModal = ({
  isOpen,
  balance,
  requiredCredits,
  loading,
  errorMessage,
  onProceed,
  onBuyCredits,
  onClose,
}) => {
  if (!isOpen) {
    return null;
  }

  const freeCredits = balance?.free_credits ?? 0;
  const purchasedCredits = balance?.purchased_credits ?? 0;
  const totalCredits = balance?.total_credits ?? 0;
  const hasEnough = totalCredits >= requiredCredits;
  const shortfall = Math.max(0, requiredCredits - totalCredits);

  return (
    <div className="credit-modal-overlay">
      <div className="credit-modal-content">
        <h3>AI Zoom Credits</h3>

        <div className="credit-modal-balance">
          <div className="credit-modal-balance-item">
            <div className="label">Free</div>
            <div className="value">{freeCredits}</div>
          </div>
          <div className="credit-modal-balance-item">
            <div className="label">Purchased</div>
            <div className="value">{purchasedCredits}</div>
          </div>
          <div className="credit-modal-balance-item">
            <div className="label">Total</div>
            <div className="value total">{totalCredits}</div>
          </div>
        </div>

        <p className="credit-modal-message">
          This will use <strong>{requiredCredits}</strong> credit{requiredCredits !== 1 ? 's' : ''} for{' '}
          {requiredCredits} image{requiredCredits !== 1 ? 's' : ''}.
        </p>

        {!hasEnough && (
          <p className="credit-modal-message warning">
            You need {shortfall} more credit{shortfall !== 1 ? 's' : ''}.
          </p>
        )}

        {errorMessage && <p className="credit-modal-error">{errorMessage}</p>}

        <div className="credit-modal-actions">
          {hasEnough && (
            <button
              className="credit-modal-button proceed"
              onClick={onProceed}
              disabled={loading}
            >
              {loading ? 'Processing...' : `Use ${requiredCredits} credit${requiredCredits !== 1 ? 's' : ''} and proceed`}
            </button>
          )}
          <button
            className="credit-modal-button buy"
            onClick={onBuyCredits}
            disabled={loading}
          >
            Buy 100 credits for $2.90
          </button>
          <button
            className="credit-modal-button ghost"
            onClick={onClose}
            disabled={loading}
          >
            Not now
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreditModal;
